import React, { useState, useEffect, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext, M_Select, M_Button } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import './formsTable.css'
import M_UploadFiles from 'src/components/M_Components/M_UploadFiles/M_UploadFiles'

export default function CreateGenerator() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataGenerator, setDataGenerator] = useState(new Map())
    const [optionsGenerator, setOptionsGenerator] = useState([])
    const [generatorId, setGeneratorId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [files, setFiles] = useState([])
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServiceGenerator = new BufferService('Generator')
    const { t } = useTranslation()
    const sessionKeys = ['dataGenerator', 'optionsGenerator', 'generatorId', 'operation']


    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataGenerator, optionsGenerator, generatorId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDG = M_StateData.filter(obj => obj.key === `dataGenerator`)[0]?.value
            const tempOG = M_StateData.filter(obj => obj.key === `optionsGenerator`)[0]?.value
            const tempGI = M_StateData.filter(obj => obj.key === `generatorId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempDG || tempOG || tempGI || tempOP) {
                setDataGenerator(new Map(tempDG))
                setOptionsGenerator(tempOG)
                setGeneratorId(tempGI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getGenerator()
    }

    const getGenerator = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setGeneratorId(getId)

        ctx.setIsLoad(true)
        bufferServiceGenerator.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenList)
            setOptionsGenerator(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceGenerator.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataGenerator = response
                    responseOptions.forEach(obj => {
                        dataGenerator.set(obj.Name, valueDataGenerator[obj.Name])
                    })
                    setFiles(valueDataGenerator.DigitalArchiveGen || [])
                    setDataGenerator(new Map(dataGenerator))
                    ctx.setIsLoad(false)
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const getIcon = (file) => {
        const fileName = file.Name ?? file.name
        const fileExtension = fileName?.toLowerCase() || ""

        switch (true) {
            case fileExtension.endsWith('.pdf'):
                return "/UploadFilesImages/pdf.png"
            case fileExtension.endsWith('.txt'):
                return "/UploadFilesImages/txt.png"
            case fileExtension.endsWith('.xlsx'):
            case fileExtension.endsWith('.csv'):
                return "/UploadFilesImages/excel.png"
            case fileExtension.endsWith('.pptx'):
                return "/UploadFilesImages/powerpoint.png"
            case fileExtension.endsWith('.docx'):
            case fileExtension.endsWith('.odt'):
                return "/UploadFilesImages/office.png"
            case fileExtension.endsWith('.rar'):
            case fileExtension.endsWith('.7z'):
            case fileExtension.endsWith('.zip'):
                return "/UploadFilesImages/zip.png"
            case fileExtension.endsWith('.eml'):
                return "/UploadFilesImages/email.png"
            default:
                return "/UploadFilesImages/images.png" // fallback
        }
    }

    const generatorStructure = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataGenerator.set(index, dateValue)
        } else {
            dataGenerator.set(index, event)
        }
        setDataGenerator(new Map(dataGenerator))
    }

    const submitGenerator = () => {
        const requiredFieldsGenerator = optionsGenerator.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsGenerator) {
            if (!dataGenerator.has(field.Name) || !dataGenerator.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }

        dataGenerator.set('digitalArchivesGenRequest', files)
        console.log(Object.fromEntries(dataGenerator))

        ctx.setIsLoad(true)

        if (operation === 'edit') {
            bufferServiceGenerator.update(generatorId, Object.fromEntries(dataGenerator)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceGenerator.post(Object.fromEntries(dataGenerator)).then((response) => {
                if (response.name === 'AxiosError') {
                    if (response.response.data.Errors[0] === 'DuplicateCityCode') {
                        ctx.toastMessages("error", '', t(response.response.data.Errors[0]))
                        ctx.setIsLoad(false)
                        return
                    } else {
                        ctx.toastMessages("error", '', t("ErrorCreate"))
                        ctx.setIsLoad(false)
                        return
                    }

                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    const handleDownloadFile = (file) => {
        const fileName = file?.Name || file?.name || 'download'
        const fileData = file?.ImageBase64 || file?.imageBase64 || file?.objectURL

        if (!fileData) {
            ctx.toastMessages("error", '', t("Error"))
            return
        }

        const link = document.createElement("a")
        link.href = fileData
        link.download = fileName
        link.click()
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitGenerator}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divFormDriver' style={{ padding: '10px' }}>
                <div className='divDisplayFormDriver'>
                    {optionsGenerator.map((elem) => (
                        <div key={elem.Name}>
                            {elem.Type === 'string' ? (
                                elem.IsForeignKey ? (
                                    <M_DrawerTableTextField
                                        tableLabel={elem.NormalizedName}
                                        label={elem.NormalizedName}
                                        required={elem.Required}
                                        entity={elem.ForeignTableName}
                                        value={dataGenerator.get(elem.ForeignTableToPassId) ?
                                            {
                                                [elem.ForeignTableToPassId]: dataGenerator.get(elem.ForeignTableToPassId),
                                                [elem.ForeignKeyName]: dataGenerator.get(elem.Name)
                                            } : null}
                                        filterField={elem.ForeignKeyName}
                                        labelFields={[elem.ForeignKeyName]}
                                        onSubmitValue={obj => {
                                            if (obj) {
                                                dataGenerator.set(elem.Name, obj[elem.ForeignKeyName])
                                                dataGenerator.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                            } else {
                                                dataGenerator.set(elem.Name, null)
                                                dataGenerator.set(elem.ForeignTableToPassId, null)
                                            }
                                            setDataGenerator(new Map(dataGenerator))
                                        }}
                                        disabled={elem.disable}
                                        valueField={elem.ForeignTableToPassId}
                                    />
                                ) : (
                                    < M_InputTextField
                                        type={"text"}
                                        label={elem.NormalizedName}
                                        secondColor={"var(--color-red-dark)"}
                                        required={elem.IsRequired}
                                        onChange={(e) => generatorStructure(e.target.value, elem.Name)}
                                        value={dataGenerator.get(elem.Name) || ""}
                                    />
                                )
                            ) : elem.Type === 'int32' ? (
                                < M_InputTextField
                                    type={"number"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => generatorStructure(e.target.value, elem.Name)}
                                    value={dataGenerator.get(elem.Name) || ""}
                                />
                            ) : elem.Type === 'fueltype' || elem.Type === 'status' ? (
                                <M_Select
                                    noNone
                                    label={elem.NormalizedName}
                                    options={elem.EnumValues?.map(elem => ({
                                        label: elem.Label,
                                        value: elem.Value
                                    })) || []}
                                    onChange={(e) => generatorStructure(e.target.value, elem.Name)}
                                    value={dataGenerator.get(elem.Name) || ""}
                                    required={elem.IsRequired}
                                />
                            ) : elem.Type === 'decimal' ? (
                                <M_InputTextField
                                    type={"decimal"}
                                    label={t(elem.NormalizedName)}
                                    onChange={(e) => generatorStructure(e.target.value, elem.Name)}
                                    value={dataGenerator.get(elem.Name) || ""}
                                    required={elem.IsRequired}
                                />
                            ) : elem.Type === 'datetime' ? (
                                <M_InputTextField
                                    type={"date"}
                                    label={elem.NormalizedName}
                                    onChange={(e) => generatorStructure(e.target.value, elem.Name)}
                                    value={dataGenerator.get(elem.Name) || ""}
                                    required={elem.IsRequired}
                                />
                            ) : null}
                        </div>
                    ))}
                </div>
                <div style={{ marginTop: '20px' }}>
                    <b>{t("DigitalArchive")}</b>
                    <M_UploadFiles
                        initialFiles={files}
                        maxSize={15000000}
                        multipleFiles={true}
                        nameURL="uploadedFiles"
                        operation={operation}
                        onFilesChange={setFiles}
                    />

                    {files.length > 0 && (
                        <div>
                            <div className="divAlignFiles">
                                {files.map((file, key) => (
                                    <div key={key} className="divAlignEachFile">
                                        <img
                                            src={getIcon(file)}
                                            alt="ícone do ficheiro"
                                            style={{ width: 40, height: 40, marginRight: 8 }}
                                        />
                                        <div>
                                            <div className="fontSizeLabelsOrderService divInputObservations">
                                                <b>{file.Name}</b>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <M_Button
                                                icon={
                                                    <img
                                                        src="/icons/svgsDaNet/trash-2.svg"
                                                        alt="delete"
                                                        style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '25px', cursor: 'pointer' }}
                                                    />
                                                }
                                                tooltip={t("Delete")}
                                                onClick={() => {
                                                    const updatedFiles = files.filter((f) => f.Name !== file.Name)
                                                    setFiles(updatedFiles)
                                                }}

                                            />
                                            <M_Button
                                                icon={
                                                    <img
                                                        src="/icons/svgsDaNet/download.svg"
                                                        alt="download"
                                                        style={{ width: '25px', cursor: 'pointer' }}
                                                    />
                                                }
                                                tooltip={t("Download")}
                                                onClick={() => handleDownloadFile(file)}

                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}